import Vue from 'vue';

// Reactive shared state using Vue.observable
const state = Vue.observable({
  formulaMetricsMap: new Map(),
});

export default {
  computed: {
    // Bind the global state to a computed property so it remains reactive
    formulaMetricsMap() {
      return state.formulaMetricsMap;
    },
  },
  methods: {
    setFormulaMetricsMap(newMap) {
      state.formulaMetricsMap = newMap;
    },
  },
};